<template>
	<div class="hot-exhibition">
		<!-- 板块标题 -->
		<div class="section-title">
			<div class="section-title_left hot-exhibition-title">
				<h3>热门展销</h3>
			</div>
			<a class="section-title_more" href="javascript:void(0);" @click="handleMore">
				<span>更多+</span>
			</a>
		</div>

		<!-- 卡片列表：n * 4 排版 -->
		<div class="goods-card-list">
			<mall-goods-card
				v-for="(item, index) in goodsList"
				:key="index"
				:goods-id="item.goodsId"
				:image="item.image"
				:title="item.title"
				:price="item.price"
				:sold-count="item.soldCount"
				:contact-phone="item.contactPhone"
				:click-count="item.clickCount"
			/>
		</div>
	</div>
</template>

<script>
	import MallGoodsCard from '@/components/MallGoodsCard'

	/**
	 * @description 商城首页-热门展销板块
	 */
	export default {
		name: 'HotExhibition',
		components: {
			MallGoodsCard
		},
		props: {},
		data() {
			return {
				// 示例数据，后期可替换为接口数据
				goodsList: [
					{
						goodsId: '1',
						image: require('@/assets/mall/goods/goods-demo.png'),
						title: '软件开发服务',
						price: '面议',
						contactPhone: '1859234781',
						clickCount: 6243345
					},
					{
						goodsId: '2',
						image: require('@/assets/mall/goods/goods-demo.png'),
						title: '房地产数据服务',
						price: '20K',
						soldCount: 2659,
						clickCount: 6243345
					},
					{
						goodsId: '3',
						image: require('@/assets/mall/goods/goods-demo.png'),
						title: '软件系统集成服务',
						price: '面议',
						clickCount: 6243345
					},
					{
						goodsId: '4',
						image: require('@/assets/mall/goods/goods-demo.png'),
						title: '系统外包服务',
						price: '面议',
						clickCount: 6243345
					}
				]
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {
			// 点击更多
			handleMore() {
				// TODO: 跳转至展销列表页
				console.log('跳转至更多热门展销')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.hot-exhibition {
		width: $main-page-width;
		margin: 30px auto 0;

		// 标题图标：使用雪碧图，每个图标 32*32
		// 坐标需根据实际雪碧图资源调整，当前为占位坐标
		.hot-exhibition-title::before {
			background-image: url('~@/assets/icons.png');
			background-position: -96px -32px;
			background-repeat: no-repeat;
		}

		// 卡片列表：4列网格布局
		.goods-card-list {
			display: grid;
			grid-template-columns: repeat(4, 1fr);
			gap: 20px;
			padding: 20px;
			background: #fff;
			border-radius: 8px;
			box-shadow: 0px 0px 10px 0px rgba(51, 51, 51, 0.05);
		}
	}
</style>
